import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M44.24 22.12 32 34.333 19.76 22.12 16 25.88l16 16 16-16z" }));
export {
  a as default
};
